/* eslint-disable max-len */
import React from 'react'
import { motion } from 'framer-motion'
import { PriceHandler } from '../../redux/helper/CamelCase';

const ItemPriceTooltip = ({prod,hover, orderData, itemPriceValue, netDiscount, customStyle, onMouseEnter, onMouseLeave}) => {
    
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01]
            }} 
            id="tooltip-discountPercentage" role="tooltip" 
            className={`inline-block absolute ${hover ?'visible':'invisible'} z-[5] sm:p-2.5 p-2 bg-white rounded-lg shadow-s2 sm:w-[225px] w-[210px] ml-2`}
            style={customStyle}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}>          
            <div className="flex items-center justify-between">
                <p className="text-sm font-normal text-[#555259]">Unit Rate </p>
                <p className="text-lg font-semibold text-[#555259]">{
                    PriceHandler(itemPriceValue)}</p>
            </div>
            {netDiscount !== undefined && (
                <div className="flex items-center justify-between mt-2">
                    <p className="text-sm font-normal text-[#555259]">Net Discount </p>
                    <p className="text-lg font-semibold text-[#555259]">{
                        Number(netDiscount).toFixed(2)}%</p>
                </div>
            )}
            <div className="tooltip-arrow" data-popper-arrow></div>
        </motion.div>
    )
}

export default ItemPriceTooltip